import store from '@/store';
export default class ErrorHandler {
    static updated(message) {
        ErrorHandler.alert(message, 'Update Available', 'warning');
    }
    static network(error) {
        const response = error.response;
        if (response) {
            switch (response.status) {
                case 422:
                    const errors = [];
                    Object.keys(response.data.errors).forEach((name) => {
                        errors.push(response.data.errors[name]);
                    });
                    const message = errors.length >= 1 ? errors.join('<br />') : response.data.message;
                    return ErrorHandler.alert(message, response.statusText);
            }
            return ErrorHandler.alert(response.status.toString(), response.statusText);
        }
        return ErrorHandler.alert();
    }
    static alert(message = 'An unknown error occured', title = 'Error', type = 'error') {
        const options = {
            title,
            text: message,
            type,
            buttons: {
                confirm: {
                    text: 'Ok',
                },
            },
        };
        store.dispatch('openDialog', options);
    }
}
